export const extractAttributeValue = (objects: any[], attributeName: string): any => {
  if (Array.isArray(objects)) {
    const objectWithAttribute = objects.find((obj) => obj.name === attributeName);
    return objectWithAttribute ? objectWithAttribute.values[0] : null;
  }
  return null;
};

export const getAttributeValue = (list: any[], attr: string) =>
  list?.find((obj) => obj.name === attr)?.values?.[0] || list?.find((obj) => obj.name === attr)?.value || null;
